import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4d8804cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "contain"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "more"
};
import router from '@/router';
export default {
  __name: 'index',
  props: {
    courseTitle: String,
    moreText: String,
    coursePlayType: String,
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    const props = __props;
    const onClickMore = coursePlayType => {
      router.push({
        path: '/course',
        query: {
          coursePlayType: coursePlayType
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(props.courseTitle), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
        text: "",
        class: "more-text",
        onClick: _cache[0] || (_cache[0] = $event => onClickMore(__props.coursePlayType))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(props.moreText) + " ", 1), __props.showIcon ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          name: "el-icon-ArrowRight"
        })) : _createCommentVNode("", true)]),
        _: 1
      })])]);
    };
  }
};